import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDemoTooltips extends Layout {
    buttonChevron: Button;
    button_normal: Button;
    checkboxAllowNested: Checkbox;
    checkboxDisabledTooltipSource: Checkbox;
    checkboxDynamicSourceAsync: Checkbox;
    checkboxDynamicSourceSync: Checkbox;
    checkboxQuickInfoSource: Checkbox;
    checkboxShakeTooltip: Checkbox;
    checkboxTooltipSource: Checkbox;
    checkboxValidationWarningSource: Checkbox;
    horizontalspacerRow1Left: HorizontalSpacer;
    horizontalspacerRow1Right: HorizontalSpacer;
    horizontalspacerRow2Left: HorizontalSpacer;
    horizontalspacerRow2Right: HorizontalSpacer;
    horizontalspacerRow3Left: HorizontalSpacer;
    horizontalspacerRow3Right: HorizontalSpacer;
    labelFieldOptionsTitle: Label;
    labelHeaderTitle: Label;
    labelOpenInNewTab1: Label;
    labelOpenInNewTab2: Label;
    labelTooltipOptionsTitle: Label;
    labelTooltipSourcesTitle: Label;
    layoutheaderTooltipPositioning: LayoutHeader;
    panelBulletedLabelContainer: Panel;
    panelFieldOptions: Panel;
    panelHeader: Panel;
    panelLinkContainer: Panel;
    panelLower: Panel;
    panelLowerRow1: Panel;
    panelLowerRow2: Panel;
    panelLowerRow3: Panel;
    panelTooltipOptions: Panel;
    panelTooltipSources: Panel;
    panelVerticalSpacerLower: Panel;
    panelVerticalSpacerUpper: Panel;
    sourceOrdersList: DataSource;
    switchPrintable: Switch;
    textboxFieldType: Textbox;
    textboxPosition: Textbox;
    textbox_multiCurrency: Textbox;
    textbox_multiSelectDropdown: Textbox;
    textbox_multiSelectTypeAhead: Textbox;
    textbox_normal: Textbox;
    textbox_singleSelectDropdown: Textbox;
    textbox_singleSelectTypeAhead: Textbox;
}
